import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ErrorDialogComponent } from './modules/errors/error-dialog/error-dialog.component';
import { ErrorRegionComponent } from './modules/errors/error-region/error-region.component';
import { ExitPageComponent } from './modules/errors/exit-page/exit-page.component';
import { LoadingComponent } from './shared-components/loading/loading.component';
import { SharedComponentsModule } from './shared-components/shared-components.module';

const sharedComponents = [ErrorDialogComponent, ExitPageComponent, LoadingComponent, ErrorRegionComponent];
@NgModule({
  declarations: [...sharedComponents],
  imports: [
    CommonModule,
    RouterModule,
    MatDialogModule,
    HttpClientModule,
    SharedComponentsModule,
    TranslateModule.forChild({ extend: true }),
  ],
  exports: [MatDialogModule, TranslateModule, ...sharedComponents],
  providers: [],
  entryComponents: [...sharedComponents],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedModule {}
